var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestimonialDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 182,
    viewBox: "0 0 260 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72906 6.77313L5.39337 15.1438C5.08635 15.7365 5.43609 16.4579 6.09203 16.5849L8.68437 17.0868C9.22571 17.1916 9.74965 16.839 9.85586 16.2985L11.5992 7.42596C11.8221 6.2917 10.2607 5.74666 9.72906 6.77313Z",
    fill: "url(#paint0_linear_66_545)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7916 6.77313L29.4559 15.1438C29.1489 15.7365 29.4986 16.4579 30.1545 16.5849L32.7469 17.0868C33.2882 17.1916 33.8121 16.839 33.9184 16.2985L35.6617 7.42597C35.8846 6.2917 34.3232 5.74666 33.7916 6.77313Z",
    fill: "url(#paint1_linear_66_545)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8619 6.76922L53.5262 15.1398C53.2192 15.7326 53.5689 16.454 54.2248 16.581L56.8172 17.0829C57.3585 17.1877 57.8825 16.8351 57.9887 16.2946L59.732 7.42206C59.9549 6.2878 58.3935 5.74275 57.8619 6.76922Z",
    fill: "url(#paint2_linear_66_545)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9322 6.77313L77.5965 15.1438C77.2895 15.7365 77.6392 16.4579 78.2952 16.5849L80.8875 17.0868C81.4288 17.1916 81.9528 16.839 82.059 16.2985L83.8023 7.42596C84.0252 6.2917 82.4639 5.74666 81.9322 6.77313Z",
    fill: "url(#paint3_linear_66_545)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.995 6.76922L101.659 15.1398C101.352 15.7326 101.702 16.454 102.358 16.581L104.95 17.0829C105.491 17.1877 106.015 16.8351 106.121 16.2946L107.865 7.42206C108.088 6.2878 106.526 5.74275 105.995 6.76922Z",
    fill: "url(#paint4_linear_66_545)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.065 6.77313L125.729 15.1438C125.422 15.7365 125.772 16.4579 126.428 16.5849L129.02 17.0868C129.562 17.1916 130.086 16.839 130.192 16.2985L131.935 7.42596C132.158 6.2917 130.597 5.74666 130.065 6.77313Z",
    fill: "url(#paint5_linear_66_545)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.127 6.77313L149.792 15.1438C149.485 15.7365 149.835 16.4579 150.49 16.5849L153.083 17.0868C153.624 17.1916 154.148 16.839 154.254 16.2985L155.998 7.42597C156.221 6.2917 154.659 5.74666 154.127 6.77313Z",
    fill: "url(#paint6_linear_66_545)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.198 6.76922L173.862 15.1398C173.555 15.7326 173.905 16.454 174.561 16.581L177.153 17.0829C177.694 17.1877 178.218 16.8351 178.325 16.2946L180.068 7.42206C180.291 6.2878 178.729 5.74275 178.198 6.76922Z",
    fill: "url(#paint7_linear_66_545)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202.276 6.77313L197.94 15.1438C197.633 15.7365 197.983 16.4579 198.639 16.5849L201.231 17.0868C201.773 17.1916 202.297 16.839 202.403 16.2985L204.146 7.42597C204.369 6.2917 202.808 5.74666 202.276 6.77313Z",
    fill: "url(#paint8_linear_66_545)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M226.362 6.76922L222.026 15.1398C221.719 15.7326 222.069 16.454 222.725 16.581L225.317 17.0829C225.859 17.1877 226.382 16.8351 226.489 16.2946L228.232 7.42206C228.455 6.2878 226.894 5.74275 226.362 6.76922Z",
    fill: "url(#paint9_linear_66_545)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44 6.77313L246.104 15.1438C245.797 15.7365 246.147 16.4579 246.803 16.5849L249.395 17.0868C249.937 17.1916 250.461 16.839 250.567 16.2985L252.31 7.42596C252.533 6.2917 250.972 5.74666 250.44 6.77313Z",
    fill: "url(#paint10_linear_66_545)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72906 39.1442L5.39337 47.5148C5.08635 48.1076 5.43609 48.829 6.09203 48.956L8.68437 49.4579C9.22571 49.5627 9.74965 49.2101 9.85586 48.6696L11.5992 39.7971C11.8221 38.6628 10.2607 38.1178 9.72906 39.1442Z",
    fill: "url(#paint11_linear_66_545)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7916 39.1481L29.4559 47.5188C29.1489 48.1115 29.4986 48.8329 30.1545 48.9599L32.7469 49.4618C33.2882 49.5666 33.8121 49.214 33.9184 48.6735L35.6617 39.801C35.8846 38.6667 34.3232 38.1217 33.7916 39.1481Z",
    fill: "url(#paint12_linear_66_545)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8619 39.1442L53.5262 47.5148C53.2192 48.1076 53.5689 48.829 54.2248 48.956L56.8172 49.4579C57.3585 49.5627 57.8825 49.2101 57.9887 48.6696L59.732 39.7971C59.9549 38.6628 58.3935 38.1178 57.8619 39.1442Z",
    fill: "url(#paint13_linear_66_545)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9322 39.1481L77.5965 47.5188C77.2895 48.1115 77.6392 48.8329 78.2952 48.9599L80.8875 49.4618C81.4288 49.5666 81.9528 49.214 82.059 48.6735L83.8023 39.801C84.0252 38.6667 82.4639 38.1217 81.9322 39.1481Z",
    fill: "url(#paint14_linear_66_545)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.995 39.1442L101.659 47.5148C101.352 48.1076 101.702 48.829 102.358 48.956L104.95 49.4579C105.491 49.5627 106.015 49.2101 106.121 48.6696L107.865 39.7971C108.088 38.6628 106.526 38.1178 105.995 39.1442Z",
    fill: "url(#paint15_linear_66_545)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M130.065 39.1481L125.729 47.5188C125.422 48.1115 125.772 48.8329 126.428 48.9599L129.02 49.4618C129.562 49.5666 130.086 49.214 130.192 48.6735L131.935 39.801C132.158 38.6667 130.597 38.1217 130.065 39.1481Z",
    fill: "url(#paint16_linear_66_545)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M154.127 39.1481L149.792 47.5188C149.485 48.1115 149.835 48.8329 150.49 48.9599L153.083 49.4618C153.624 49.5666 154.148 49.214 154.254 48.6735L155.998 39.801C156.221 38.6667 154.659 38.1217 154.127 39.1481Z",
    fill: "url(#paint17_linear_66_545)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M178.198 39.1442L173.862 47.5148C173.555 48.1076 173.905 48.829 174.561 48.956L177.153 49.4579C177.694 49.5627 178.218 49.2101 178.325 48.6696L180.068 39.7971C180.291 38.6628 178.729 38.1178 178.198 39.1442Z",
    fill: "url(#paint18_linear_66_545)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M202.276 39.1481L197.94 47.5188C197.633 48.1115 197.983 48.8329 198.639 48.9599L201.231 49.4618C201.773 49.5666 202.297 49.214 202.403 48.6735L204.146 39.801C204.369 38.6667 202.808 38.1217 202.276 39.1481Z",
    fill: "url(#paint19_linear_66_545)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M226.362 39.1442L222.026 47.5148C221.719 48.1076 222.069 48.829 222.725 48.956L225.317 49.4579C225.859 49.5627 226.382 49.2101 226.489 48.6696L228.232 39.7971C228.455 38.6628 226.894 38.1178 226.362 39.1442Z",
    fill: "url(#paint20_linear_66_545)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44 39.1481L246.104 47.5188C245.797 48.1115 246.147 48.8329 246.803 48.9599L249.395 49.4618C249.937 49.5666 250.461 49.214 250.567 48.6735L252.31 39.801C252.533 38.6667 250.972 38.1217 250.44 39.1481Z",
    fill: "url(#paint21_linear_66_545)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72906 71.5231L5.39337 79.8938C5.08635 80.4865 5.43609 81.2079 6.09203 81.3349L8.68437 81.8368C9.22571 81.9416 9.74965 81.589 9.85586 81.0485L11.5992 72.176C11.8221 71.0417 10.2607 70.4967 9.72906 71.5231Z",
    fill: "url(#paint22_linear_66_545)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7916 71.5231L29.4559 79.8938C29.1489 80.4865 29.4986 81.2079 30.1545 81.3349L32.7469 81.8368C33.2882 81.9416 33.8121 81.589 33.9184 81.0485L35.6617 72.176C35.8846 71.0417 34.3232 70.4967 33.7916 71.5231Z",
    fill: "url(#paint23_linear_66_545)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8619 71.5192L53.5262 79.8898C53.2192 80.4826 53.5689 81.204 54.2248 81.331L56.8172 81.8329C57.3585 81.9377 57.8825 81.5851 57.9887 81.0446L59.732 72.1721C59.9549 71.0378 58.3935 70.4928 57.8619 71.5192Z",
    fill: "url(#paint24_linear_66_545)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9322 71.5231L77.5965 79.8938C77.2895 80.4865 77.6392 81.2079 78.2952 81.3349L80.8875 81.8368C81.4288 81.9416 81.9528 81.589 82.059 81.0485L83.8023 72.176C84.0252 71.0417 82.4639 70.4967 81.9322 71.5231Z",
    fill: "url(#paint25_linear_66_545)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M105.995 71.5192L101.659 79.8898C101.352 80.4826 101.702 81.204 102.358 81.331L104.95 81.8329C105.491 81.9377 106.015 81.5851 106.121 81.0446L107.865 72.1721C108.088 71.0378 106.526 70.4928 105.995 71.5192Z",
    fill: "url(#paint26_linear_66_545)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M130.065 71.5231L125.729 79.8938C125.422 80.4865 125.772 81.2079 126.428 81.3349L129.02 81.8368C129.562 81.9416 130.086 81.589 130.192 81.0485L131.935 72.176C132.158 71.0417 130.597 70.4967 130.065 71.5231Z",
    fill: "url(#paint27_linear_66_545)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M154.127 71.5231L149.792 79.8938C149.485 80.4865 149.835 81.2079 150.49 81.3349L153.083 81.8368C153.624 81.9416 154.148 81.589 154.254 81.0485L155.998 72.176C156.221 71.0417 154.659 70.4967 154.127 71.5231Z",
    fill: "url(#paint28_linear_66_545)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M178.198 71.5192L173.862 79.8898C173.555 80.4826 173.905 81.204 174.561 81.331L177.153 81.8329C177.694 81.9377 178.218 81.5851 178.325 81.0446L180.068 72.1721C180.291 71.0378 178.729 70.4928 178.198 71.5192Z",
    fill: "url(#paint29_linear_66_545)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M202.276 71.5231L197.94 79.8938C197.633 80.4865 197.983 81.2079 198.639 81.3349L201.231 81.8368C201.773 81.9416 202.297 81.589 202.403 81.0485L204.146 72.176C204.369 71.0417 202.808 70.4967 202.276 71.5231Z",
    fill: "url(#paint30_linear_66_545)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M226.362 71.5192L222.026 79.8898C221.719 80.4826 222.069 81.204 222.725 81.331L225.317 81.8329C225.859 81.9377 226.382 81.5851 226.489 81.0446L228.232 72.1721C228.455 71.0378 226.894 70.4928 226.362 71.5192Z",
    fill: "url(#paint31_linear_66_545)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44 71.5231L246.104 79.8938C245.797 80.4865 246.147 81.2079 246.803 81.3349L249.395 81.8368C249.937 81.9416 250.461 81.589 250.567 81.0485L252.31 72.176C252.533 71.0417 250.972 70.4967 250.44 71.5231Z",
    fill: "url(#paint32_linear_66_545)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72906 103.894L5.39337 112.265C5.08635 112.858 5.43609 113.579 6.09203 113.706L8.68437 114.208C9.22571 114.313 9.74965 113.96 9.85586 113.42L11.5992 104.547C11.8221 103.413 10.2607 102.868 9.72906 103.894Z",
    fill: "url(#paint33_linear_66_545)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7916 103.898L29.4559 112.269C29.1489 112.861 29.4986 113.583 30.1545 113.71L32.7469 114.212C33.2882 114.317 33.8121 113.964 33.9184 113.423L35.6617 104.551C35.8846 103.417 34.3232 102.872 33.7916 103.898Z",
    fill: "url(#paint34_linear_66_545)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8619 103.894L53.5262 112.265C53.2192 112.858 53.5689 113.579 54.2248 113.706L56.8172 114.208C57.3585 114.313 57.8825 113.96 57.9887 113.42L59.732 104.547C59.9549 103.413 58.3935 102.868 57.8619 103.894Z",
    fill: "url(#paint35_linear_66_545)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9322 103.898L77.5965 112.269C77.2895 112.861 77.6392 113.583 78.2952 113.71L80.8875 114.212C81.4288 114.317 81.9528 113.964 82.059 113.423L83.8023 104.551C84.0252 103.417 82.4639 102.872 81.9322 103.898Z",
    fill: "url(#paint36_linear_66_545)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M105.995 103.894L101.659 112.265C101.352 112.858 101.702 113.579 102.358 113.706L104.95 114.208C105.491 114.313 106.015 113.96 106.121 113.42L107.865 104.547C108.088 103.413 106.526 102.868 105.995 103.894Z",
    fill: "url(#paint37_linear_66_545)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M130.065 103.898L125.729 112.269C125.422 112.861 125.772 113.583 126.428 113.71L129.02 114.212C129.562 114.317 130.086 113.964 130.192 113.423L131.935 104.551C132.158 103.417 130.597 102.872 130.065 103.898Z",
    fill: "url(#paint38_linear_66_545)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M154.127 103.898L149.792 112.269C149.485 112.861 149.835 113.583 150.49 113.71L153.083 114.212C153.624 114.317 154.148 113.964 154.254 113.423L155.998 104.551C156.221 103.417 154.659 102.872 154.127 103.898Z",
    fill: "url(#paint39_linear_66_545)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M178.198 103.894L173.862 112.265C173.555 112.858 173.905 113.579 174.561 113.706L177.153 114.208C177.694 114.313 178.218 113.96 178.325 113.42L180.068 104.547C180.291 103.413 178.729 102.868 178.198 103.894Z",
    fill: "url(#paint40_linear_66_545)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M202.276 103.898L197.94 112.269C197.633 112.861 197.983 113.583 198.639 113.71L201.231 114.212C201.773 114.317 202.297 113.964 202.403 113.423L204.146 104.551C204.369 103.417 202.808 102.872 202.276 103.898Z",
    fill: "url(#paint41_linear_66_545)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M226.362 103.894L222.026 112.265C221.719 112.858 222.069 113.579 222.725 113.706L225.317 114.208C225.859 114.313 226.382 113.96 226.489 113.42L228.232 104.547C228.455 103.413 226.894 102.868 226.362 103.894Z",
    fill: "url(#paint42_linear_66_545)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44 103.898L246.104 112.269C245.797 112.861 246.147 113.583 246.803 113.71L249.395 114.212C249.937 114.317 250.461 113.964 250.567 113.423L252.31 104.551C252.533 103.417 250.972 102.872 250.44 103.898Z",
    fill: "url(#paint43_linear_66_545)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72906 136.273L5.39337 144.644C5.08635 145.236 5.43609 145.958 6.09203 146.085L8.68437 146.587C9.22571 146.692 9.74965 146.339 9.85586 145.798L11.5992 136.926C11.8221 135.792 10.2607 135.247 9.72906 136.273Z",
    fill: "url(#paint44_linear_66_545)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7916 136.273L29.4559 144.644C29.1489 145.236 29.4986 145.958 30.1545 146.085L32.7469 146.587C33.2882 146.692 33.8121 146.339 33.9184 145.798L35.6617 136.926C35.8846 135.792 34.3232 135.247 33.7916 136.273Z",
    fill: "url(#paint45_linear_66_545)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8619 136.269L53.5262 144.64C53.2192 145.233 53.5689 145.954 54.2248 146.081L56.8172 146.583C57.3585 146.688 57.8825 146.335 57.9887 145.795L59.732 136.922C59.9549 135.788 58.3935 135.243 57.8619 136.269Z",
    fill: "url(#paint46_linear_66_545)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9322 136.273L77.5965 144.644C77.2895 145.236 77.6392 145.958 78.2952 146.085L80.8875 146.587C81.4288 146.692 81.9528 146.339 82.059 145.798L83.8023 136.926C84.0252 135.792 82.4639 135.247 81.9322 136.273Z",
    fill: "url(#paint47_linear_66_545)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M105.995 136.269L101.659 144.64C101.352 145.233 101.702 145.954 102.358 146.081L104.95 146.583C105.491 146.688 106.015 146.335 106.121 145.795L107.865 136.922C108.088 135.788 106.526 135.243 105.995 136.269Z",
    fill: "url(#paint48_linear_66_545)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.065 136.273L125.729 144.644C125.422 145.236 125.772 145.958 126.428 146.085L129.02 146.587C129.562 146.692 130.086 146.339 130.192 145.798L131.935 136.926C132.158 135.792 130.597 135.247 130.065 136.273Z",
    fill: "url(#paint49_linear_66_545)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M154.127 136.273L149.792 144.644C149.485 145.236 149.835 145.958 150.49 146.085L153.083 146.587C153.624 146.692 154.148 146.339 154.254 145.798L155.998 136.926C156.221 135.792 154.659 135.247 154.127 136.273Z",
    fill: "url(#paint50_linear_66_545)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M178.198 136.269L173.862 144.64C173.555 145.233 173.905 145.954 174.561 146.081L177.153 146.583C177.694 146.688 178.218 146.335 178.325 145.795L180.068 136.922C180.291 135.788 178.729 135.243 178.198 136.269Z",
    fill: "url(#paint51_linear_66_545)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M202.276 136.273L197.94 144.644C197.633 145.236 197.983 145.958 198.639 146.085L201.231 146.587C201.773 146.692 202.297 146.339 202.403 145.798L204.146 136.926C204.369 135.792 202.808 135.247 202.276 136.273Z",
    fill: "url(#paint52_linear_66_545)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M226.362 136.269L222.026 144.64C221.719 145.233 222.069 145.954 222.725 146.081L225.317 146.583C225.859 146.688 226.382 146.335 226.489 145.795L228.232 136.922C228.455 135.788 226.894 135.243 226.362 136.269Z",
    fill: "url(#paint53_linear_66_545)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44 136.273L246.104 144.644C245.797 145.236 246.147 145.958 246.803 146.085L249.395 146.587C249.937 146.692 250.461 146.339 250.567 145.798L252.31 136.926C252.533 135.792 250.972 135.247 250.44 136.273Z",
    fill: "url(#paint54_linear_66_545)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72906 168.644L5.39337 177.015C5.08635 177.608 5.43609 178.329 6.09203 178.456L8.68437 178.958C9.22571 179.063 9.74965 178.71 9.85586 178.17L11.5992 169.297C11.8221 168.163 10.2607 167.618 9.72906 168.644Z",
    fill: "url(#paint55_linear_66_545)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7916 168.648L29.4559 177.019C29.1489 177.611 29.4986 178.333 30.1545 178.46L32.7469 178.962C33.2882 179.067 33.8121 178.714 33.9184 178.173L35.6617 169.301C35.8846 168.167 34.3232 167.622 33.7916 168.648Z",
    fill: "url(#paint56_linear_66_545)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8619 168.644L53.5262 177.015C53.2192 177.608 53.5689 178.329 54.2248 178.456L56.8172 178.958C57.3585 179.063 57.8825 178.71 57.9887 178.17L59.732 169.297C59.9549 168.163 58.3935 167.618 57.8619 168.644Z",
    fill: "url(#paint57_linear_66_545)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9322 168.648L77.5965 177.019C77.2895 177.611 77.6392 178.333 78.2952 178.46L80.8875 178.962C81.4288 179.067 81.9528 178.714 82.059 178.173L83.8023 169.301C84.0252 168.167 82.4639 167.622 81.9322 168.648Z",
    fill: "url(#paint58_linear_66_545)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M105.995 168.644L101.659 177.015C101.352 177.608 101.702 178.329 102.358 178.456L104.95 178.958C105.491 179.063 106.015 178.71 106.121 178.17L107.865 169.297C108.088 168.163 106.526 167.618 105.995 168.644Z",
    fill: "url(#paint59_linear_66_545)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M130.065 168.648L125.729 177.019C125.422 177.611 125.772 178.333 126.428 178.46L129.02 178.962C129.562 179.067 130.086 178.714 130.192 178.173L131.935 169.301C132.158 168.167 130.597 167.622 130.065 168.648Z",
    fill: "url(#paint60_linear_66_545)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M154.127 168.648L149.792 177.019C149.485 177.611 149.835 178.333 150.49 178.46L153.083 178.962C153.624 179.067 154.148 178.714 154.254 178.173L155.998 169.301C156.221 168.167 154.659 167.622 154.127 168.648Z",
    fill: "url(#paint61_linear_66_545)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M178.198 168.644L173.862 177.015C173.555 177.608 173.905 178.329 174.561 178.456L177.153 178.958C177.694 179.063 178.218 178.71 178.325 178.17L180.068 169.297C180.291 168.163 178.729 167.618 178.198 168.644Z",
    fill: "url(#paint62_linear_66_545)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M202.276 168.648L197.94 177.019C197.633 177.611 197.983 178.333 198.639 178.46L201.231 178.962C201.773 179.067 202.297 178.714 202.403 178.173L204.146 169.301C204.369 168.167 202.808 167.622 202.276 168.648Z",
    fill: "url(#paint63_linear_66_545)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M226.362 168.644L222.026 177.015C221.719 177.608 222.069 178.329 222.725 178.456L225.317 178.958C225.859 179.063 226.382 178.71 226.489 178.17L228.232 169.297C228.455 168.163 226.894 167.618 226.362 168.644Z",
    fill: "url(#paint64_linear_66_545)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44 168.648L246.104 177.019C245.797 177.611 246.147 178.333 246.803 178.46L249.395 178.962C249.937 179.067 250.461 178.714 250.567 178.173L252.31 169.301C252.533 168.167 250.972 167.622 250.44 168.648Z",
    fill: "url(#paint65_linear_66_545)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_545",
    x1: 6.47446,
    y1: 4.16119,
    x2: 12.803,
    y2: 15.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_545",
    x1: 30.537,
    y1: 4.16119,
    x2: 36.8655,
    y2: 15.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_66_545",
    x1: 54.6073,
    y1: 4.15728,
    x2: 60.9358,
    y2: 15.5248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_66_545",
    x1: 78.6776,
    y1: 4.16119,
    x2: 85.0061,
    y2: 15.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_66_545",
    x1: 102.74,
    y1: 4.15728,
    x2: 109.069,
    y2: 15.5248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_66_545",
    x1: 126.81,
    y1: 4.16119,
    x2: 133.139,
    y2: 15.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_66_545",
    x1: 150.873,
    y1: 4.16119,
    x2: 157.201,
    y2: 15.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_66_545",
    x1: 174.943,
    y1: 4.15728,
    x2: 181.272,
    y2: 15.5248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_66_545",
    x1: 199.021,
    y1: 4.16119,
    x2: 205.35,
    y2: 15.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_66_545",
    x1: 223.107,
    y1: 4.15728,
    x2: 229.436,
    y2: 15.5248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_66_545",
    x1: 247.185,
    y1: 4.16119,
    x2: 253.514,
    y2: 15.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_66_545",
    x1: 6.47446,
    y1: 36.5323,
    x2: 12.803,
    y2: 47.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_66_545",
    x1: 30.537,
    y1: 36.5362,
    x2: 36.8655,
    y2: 47.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_66_545",
    x1: 54.6073,
    y1: 36.5323,
    x2: 60.9358,
    y2: 47.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_66_545",
    x1: 78.6776,
    y1: 36.5362,
    x2: 85.0061,
    y2: 47.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_66_545",
    x1: 102.74,
    y1: 36.5323,
    x2: 109.069,
    y2: 47.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_66_545",
    x1: 126.81,
    y1: 36.5362,
    x2: 133.139,
    y2: 47.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_66_545",
    x1: 150.873,
    y1: 36.5362,
    x2: 157.201,
    y2: 47.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_66_545",
    x1: 174.943,
    y1: 36.5323,
    x2: 181.272,
    y2: 47.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_66_545",
    x1: 199.021,
    y1: 36.5362,
    x2: 205.35,
    y2: 47.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_66_545",
    x1: 223.107,
    y1: 36.5323,
    x2: 229.436,
    y2: 47.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_66_545",
    x1: 247.185,
    y1: 36.5362,
    x2: 253.514,
    y2: 47.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_66_545",
    x1: 6.47446,
    y1: 68.9112,
    x2: 12.803,
    y2: 80.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_66_545",
    x1: 30.537,
    y1: 68.9112,
    x2: 36.8655,
    y2: 80.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_66_545",
    x1: 54.6073,
    y1: 68.9073,
    x2: 60.9358,
    y2: 80.2748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_66_545",
    x1: 78.6776,
    y1: 68.9112,
    x2: 85.0061,
    y2: 80.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_66_545",
    x1: 102.74,
    y1: 68.9073,
    x2: 109.069,
    y2: 80.2748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_66_545",
    x1: 126.81,
    y1: 68.9112,
    x2: 133.139,
    y2: 80.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_66_545",
    x1: 150.873,
    y1: 68.9112,
    x2: 157.201,
    y2: 80.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_66_545",
    x1: 174.943,
    y1: 68.9073,
    x2: 181.272,
    y2: 80.2748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_66_545",
    x1: 199.021,
    y1: 68.9112,
    x2: 205.35,
    y2: 80.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_66_545",
    x1: 223.107,
    y1: 68.9073,
    x2: 229.436,
    y2: 80.2748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_66_545",
    x1: 247.185,
    y1: 68.9112,
    x2: 253.514,
    y2: 80.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_66_545",
    x1: 6.47446,
    y1: 101.282,
    x2: 12.803,
    y2: 112.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_66_545",
    x1: 30.537,
    y1: 101.286,
    x2: 36.8655,
    y2: 112.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_66_545",
    x1: 54.6073,
    y1: 101.282,
    x2: 60.9358,
    y2: 112.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_66_545",
    x1: 78.6776,
    y1: 101.286,
    x2: 85.0061,
    y2: 112.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_66_545",
    x1: 102.74,
    y1: 101.282,
    x2: 109.069,
    y2: 112.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_66_545",
    x1: 126.81,
    y1: 101.286,
    x2: 133.139,
    y2: 112.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_66_545",
    x1: 150.873,
    y1: 101.286,
    x2: 157.201,
    y2: 112.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_66_545",
    x1: 174.943,
    y1: 101.282,
    x2: 181.272,
    y2: 112.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_66_545",
    x1: 199.021,
    y1: 101.286,
    x2: 205.35,
    y2: 112.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_66_545",
    x1: 223.107,
    y1: 101.282,
    x2: 229.436,
    y2: 112.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_66_545",
    x1: 247.185,
    y1: 101.286,
    x2: 253.514,
    y2: 112.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.80916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_66_545",
    x1: 6.47446,
    y1: 133.661,
    x2: 12.803,
    y2: 145.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_66_545",
    x1: 30.537,
    y1: 133.661,
    x2: 36.8655,
    y2: 145.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_66_545",
    x1: 54.6073,
    y1: 133.657,
    x2: 60.9358,
    y2: 145.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_66_545",
    x1: 78.6776,
    y1: 133.661,
    x2: 85.0061,
    y2: 145.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_66_545",
    x1: 102.74,
    y1: 133.657,
    x2: 109.069,
    y2: 145.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_66_545",
    x1: 126.81,
    y1: 133.661,
    x2: 133.139,
    y2: 145.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_66_545",
    x1: 150.873,
    y1: 133.661,
    x2: 157.201,
    y2: 145.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_66_545",
    x1: 174.943,
    y1: 133.657,
    x2: 181.272,
    y2: 145.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_66_545",
    x1: 199.021,
    y1: 133.661,
    x2: 205.35,
    y2: 145.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_66_545",
    x1: 223.107,
    y1: 133.657,
    x2: 229.436,
    y2: 145.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_66_545",
    x1: 247.185,
    y1: 133.661,
    x2: 253.514,
    y2: 145.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_66_545",
    x1: 6.47446,
    y1: 166.032,
    x2: 12.803,
    y2: 177.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_66_545",
    x1: 30.537,
    y1: 166.036,
    x2: 36.8655,
    y2: 177.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_66_545",
    x1: 54.6073,
    y1: 166.032,
    x2: 60.9358,
    y2: 177.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_66_545",
    x1: 78.6776,
    y1: 166.036,
    x2: 85.0061,
    y2: 177.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_66_545",
    x1: 102.74,
    y1: 166.032,
    x2: 109.069,
    y2: 177.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_66_545",
    x1: 126.81,
    y1: 166.036,
    x2: 133.139,
    y2: 177.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_66_545",
    x1: 150.873,
    y1: 166.036,
    x2: 157.201,
    y2: 177.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_66_545",
    x1: 174.943,
    y1: 166.032,
    x2: 181.272,
    y2: 177.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_66_545",
    x1: 199.021,
    y1: 166.036,
    x2: 205.35,
    y2: 177.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_66_545",
    x1: 223.107,
    y1: 166.032,
    x2: 229.436,
    y2: 177.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_66_545",
    x1: 247.185,
    y1: 166.036,
    x2: 253.514,
    y2: 177.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#247EFE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialDots);
export default __webpack_public_path__ + "static/media/testimonialDots.fe337967c8c37e532f1212005484abf9.svg";
export { ForwardRef as ReactComponent };